import backgroundSemiFinals from "@images/backgroundBenchmark.png"
import LogoSemiFinals from "@images/crossfit/logo_crossfit_semiFinals.png"
import { word } from "@modules/core/utils/i18n"
import { CrossfitEventDetailsInfo } from "@modules/crossfitEvent/components/crossfitEventDetailsInfo"
import { CrossFitEvent } from "@modules/crossfitEvent/entities/crossfitEventEntity"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { HUText } from "@modules/ui/components/huText"
import dayjs from "dayjs"
import styled, { useTheme } from "styled-components"
type CrossfitEventCardProps = {
  crossfitEvent: CrossFitEvent
}

export const CrossfitEventCard: React.FC<CrossfitEventCardProps> = ({ crossfitEvent }) => {
  const theme = useTheme()

  const { sidebarNavigateTo } = useSidebar()

  const onOpenSemiFinalResume = () => {
    sidebarNavigateTo({
      content: <CrossfitEventDetailsInfo crossfitEvent={crossfitEvent} />,
      replaceAllComponents: true,
    })
  }

  return (
    <CardContainer onClick={onOpenSemiFinalResume}>
      <CrossfitLogo />
      <LogoSemiFinalCompetition $logoSemiFinal={crossfitEvent.logo?.uri || ""} />
      <InformationsContainer>
        <HUText fontStyle="LM">
        {dayjs(crossfitEvent.date.start).format("ll")} -{" "}
        {dayjs(crossfitEvent.date.end).format("ll")}
        </HUText>
        <HUText fontStyle="LM">{crossfitEvent.card.subtitle}</HUText>
        <div className="flex align-items-center justify-content-between w-full">
          <HUText fontStyle="TM" className="max-w-9rem">
          {crossfitEvent.card.title}
          </HUText>
          <SeeMoreButton>
            <i className="pi pi-info-circle mr-2" />
            <HUText fontStyle="LM" color={theme.neutralColor900}>
              {word(`global.learnMore`)}
            </HUText>
          </SeeMoreButton>
        </div>
      </InformationsContainer>
      <GradientOverlay />
    </CardContainer>
  )
}

const CardContainer = styled.div`
  height: 300px;
  width: 100%;
  max-width: 320px;
  border-radius: 33px;
  padding: 0px 0px 28px 0px;
  position: relative;
  overflow: hidden;
  background-image: url(${backgroundSemiFinals});
  background-size: cover;
  background-position: center;
  @media screen and (max-height: 800px) {
    height: 200px;
  }
  &:hover {
    cursor: pointer !important;
  }
`
const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 33px;
  border-width: 0px;
  height: 300px;
  width: 320px;
  z-index: 1;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(221, 242, 71, 0) 0.01%,
    rgba(221, 242, 71, 0.76) 99.9%
  );
  backdrop-filter: blur(1px);
`
const CrossfitLogo = styled.div`
  position: absolute;
  top: 7%;
  left: -4%;
  background-image: url(${LogoSemiFinals});
  background-size: contain;
  background-position: center;
  height: 14%;
  width: 50%;
  background-repeat: no-repeat;
  z-index: 100;
`
const LogoSemiFinalCompetition = styled.div<{ $logoSemiFinal: string; $heightLogo?: number; $widthLogo?: number }>`
  position: absolute;
  top: 10%;
  right: 3%;
  background-image: ${({ $logoSemiFinal }) => `url(${$logoSemiFinal})`};
  background-size: contain;
  background-position: center;
  height: ${({ $heightLogo }) => ($heightLogo ? `${$heightLogo}%` : "67%")};
  width: ${({ $widthLogo }) => ($widthLogo ? `${$widthLogo}%` : "62%")};
  background-repeat: no-repeat;
  z-index: 100;
  @media screen and (max-height: 800px) {
    background-position: right;
    top: 4%;
  }
`
const InformationsContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 15px;
  left: 22px;
  z-index: 100;
  width: calc(100% - 32px);
`
const SeeMoreButton = styled.div`
  display: flex;
  align-items: center;
  border-radius: 44px;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  padding: 9px 12px 8px 12px;
  z-index: 100;
`
